export abstract class Component extends HTMLElement {

    constructor() {
        super();
    }

    protected connectedCallback() {
        if (!this.innerHTML.trim()) {
            this.innerHTML = this.render();
        }
        this.onMount();
    }

    protected render(): string {
        // if this is being called, the component had nothing in it.
        return 'Empty component, could not render.';
    }

    protected abstract onMount(): void;

    protected disconnectedCallback() {
        this.onDestroy();
    }

    protected onDestroy(): void {}
}